// extracted by mini-css-extract-plugin
export default {"container":"styles_container__suDh5","text":"styles_text__k8m5h","selectedText":"styles_selectedText__jjTHe","emoji":"styles_emoji__LXz0m","iconStyle":"styles_iconStyle__7+eaq"};